module.exports = __webpack_public_path__ + "static/media/taImg5.6447cf85.png";